import { useTheme } from './useTheme'
import styles from './ThemeToggleButton.module.css'

/**
 * 시안 `.tbtn` 이식 — 테마 전환.
 * `useTheme` 이 `data-theme` 를 documentElement 에 실제로 반영한다(useTheme.test.ts 는
 * 순수함수 `resolveNextTheme` 만 검증했다 — 이 컴포넌트의 jsdom 테스트가 훅 자체의 DOM 반영을 닫는다).
 */
export const ThemeToggleButton = (): JSX.Element => {
  const { toggle } = useTheme()

  return (
    <button type="button" className={styles.tbtn} onClick={toggle}>
      테마 전환
    </button>
  )
}
